export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/admin/users/bicycle-owner/:id/bicycles/:bicycleId', 'admin.bicycle-owner-user-bicycle-info')
    .when('/admin/users/bicycle-owner/:id/bicycles', 'admin.bicycle-owner-user-bicycles')
    .when('/admin/users/bicycle-owner/:id/financials', 'admin.bicycle-owner-user-financials')
    .when('/admin/users/bicycle-owner/:id/info', 'admin.bicycle-owner-user-info')
    .when('/admin/users/bicycle-owner/:id/service-bookings', 'admin.bicycle-owner-user-service-bookings')
    .when('/admin/users/bicycle-owner/:id/service-bookings/:requestId', 'admin.bicycle-owner-user-service-booking-info')
    .when('/admin/users/bicycle-owner/:id/service-bookings/:requestId/reporting', 'admin.bicycle-owner-user-service-booking-reporting')
    .when('/admin/users/bicycle-owner/:id/service-bookings/:requestId/reassign', 'admin.bicycle-owner-user-service-booking-reassign')
    .when('/admin/users/bicycle-owner/:id/settings', 'admin.bicycle-owner-user-settings')

    .within('admin')

    .segment('bicycle-owner-user-bicycle-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.bicycle_owner_info',
          url: '/admin/users/bicycle-owner/:id/bicycles',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.bicycle_owner_bicycle_info',
        }
      ],
      template: '<admin-bicycle-owner-bicycle-info-page></admin-bicycle-owner-bicycle-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-owner-bicycle-info.module" */ "./bicycle-owner-bicycle-info/admin-bicycle-owner-bicycle-info.module");
      }
    })

    .segment('bicycle-owner-user-bicycles', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.bicycle_owner_info',
        }
      ],
      template: '<admin-bicycle-owner-bicycles-page></admin-bicycle-owner-bicycles-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-owner-bicycles.module" */ "./bicycle-owner-bicycles/admin-bicycle-owner-bicycles.module");
      }
    })

    .segment('bicycle-owner-user-financials', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.bicycle_owner_info',
        }
      ],
      template: '<admin-bicycle-owner-financials-page></admin-bicycle-owner-financials-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-owner-financials.module" */ "./bicycle-owner-financials/admin-bicycle-owner-financials.module");
      }
    })

    .segment('bicycle-owner-user-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.bicycle_owner_info',
        }
      ],
      template: '<admin-bicycle-owner-personal-info-page></admin-bicycle-owner-personal-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-owner-personal-info.module" */ "./bicycle-owner-personal-info/admin-bicycle-owner-personal-info.module");
      }
    })

    .segment('bicycle-owner-user-service-booking-info', {
      access: {requireLogin: true, hasAuthority: 'ADMIN', isRequest: true},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.bicycle_owner_info',
          url: '/admin/users/bicycle-owner/:id/service-bookings',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
        }
      ],
      template: '<admin-bicycle-owner-service-booking-info-page></admin-bicycle-owner-service-booking-info-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-owner-service-booking-info.module" */ "./bicycle-owner-service-booking-info/admin-bicycle-owner-service-booking-info.module");
      }
    })

    .segment('bicycle-owner-user-service-booking-reporting', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.bicycle_owner_info',
          url: '/admin/users/bicycle-owner/:id/service-bookings',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
          url: '/admin/organisations/:id/service-bookings/:requestId',
          params: {
            requestId: ':requestId',
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.booking_reporting',
        }
      ],
      template: '<admin-bicycle-owner-service-booking-reporting-page></admin-bicycle-owner-service-booking-reporting-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-owner-service-booking-reporting.module" */ "./bicycle-owner-service-booking-reporting/admin-bicycle-owner-service-booking-reporting.module");
      }
    })

    .segment('bicycle-owner-user-service-booking-reassign', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.bicycle_owner_info',
          url: '/admin/users/bicycle-owner/:id/service-bookings',
          params: {
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.service_booking_info',
          url: '/admin/users/bicycle-owner/:id/service-bookings/:requestId',
          params: {
            requestId: ':requestId',
            id: ':id'
          }
        },
        {
          label: 'admin.breadcrumb.booking_reassign',
        }
      ],
      template: '<admin-bicycle-owner-service-booking-reassign-page></admin-bicycle-owner-service-booking-reassign-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-owner-service-booking-reassign.module" */ "./bicycle-owner-service-booking-reassign/admin-bicycle-owner-service-booking-reassign.module");
      }
    })

    .segment('bicycle-owner-user-service-bookings', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.bicycle_owner_info',
        }
      ],
      template: '<admin-bicycle-owner-service-bookings-page></admin-bicycle-owner-service-bookings-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-owner-service-bookings.module" */ "./bicycle-owner-service-bookings/admin-bicycle-owner-service-bookings.module");
      }
    })

    .segment('bicycle-owner-user-settings', {
      access: {requireLogin: true, hasAuthority: 'ADMIN'},
      breadcrumb: [
        {
          label: 'admin.breadcrumb.users',
          url: '/admin/users'
        },
        {
          label: 'admin.breadcrumb.bicycle_owner_info',
        }
      ],
      template: '<admin-bicycle-owner-settings-page></admin-bicycle-owner-settings-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "admin-bicycle-owner-settings.module" */ "./bicycle-owner-settings/admin-bicycle-owner-settings.module");
      }
    })
}
